import { useEffect } from "react";
import { Link } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import { ArrowLeft } from "lucide-react";

export default function LegalPage({ title, markdown, testId }) {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${title} — InfluenceDetector`;
  }, [title]);

  return (
    <main
      data-testid={testId}
      className="min-h-screen bg-[#09090B] text-[#FAFAFA]"
    >
      {/* Header */}
      <header className="border-b border-white/5 bg-black/60 backdrop-blur-xl sticky top-0 z-40">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link
            to="/"
            data-testid="legal-home-link"
            className="flex items-center gap-2 group"
          >
            <div className="w-7 h-7 bg-[#D4FF00] flex items-center justify-center rounded-sm">
              <span className="font-display text-black text-sm">ID</span>
            </div>
            <span className="font-display uppercase tracking-tight text-sm">
              Influence<span className="text-[#D4FF00]">Detector</span>
            </span>
          </Link>
          <Link
            to="/"
            data-testid="legal-back-link"
            className="text-xs text-white/60 hover:text-white flex items-center gap-1.5"
          >
            <ArrowLeft className="w-3.5 h-3.5" />
            Back to site
          </Link>
        </div>
      </header>

      <article className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
        <div className="legal-prose">
          <ReactMarkdown>{markdown}</ReactMarkdown>
        </div>
      </article>

      <footer className="border-t border-white/5 py-10">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-xs text-[#A1A1AA]">
          <p>© {new Date().getFullYear()} Influence Detector LLC. All rights reserved.</p>
          <div className="mt-3 flex justify-center gap-6">
            <Link to="/terms" className="hover:text-white">Terms</Link>
            <Link to="/privacy" className="hover:text-white">Privacy</Link>
            <a href="mailto:support@influencedetector.com" className="hover:text-white">Contact</a>
          </div>
        </div>
      </footer>
    </main>
  );
}
